import { isEmpty } from 'lodash-es';
import React from 'react';
import { useIntersectionObserver } from 'usehooks-ts';
import { FadeContainer } from '../FadeContainer';
import { Grid } from '../Grid';
import { Body2, H5 } from '../typography';
import { logosContainer, partnersDelayVar, styledTitle } from './Partners.css';
import {
  gridOverride,
  landingContainer,
  landingTextContainer,
} from './PartnersLanding.css';
import { ScrollingLogos } from './ScrollingLogos';
import { type PartnerItem } from './ScrollingLogos/ScrollingLogos';
import { ScrollingDirection } from './ScrollingLogos/constants';

interface PartnersLandingProps {
  title: string;
  subtitle?: string;
  topPartners?: PartnerItem[];
  bottomPartners?: PartnerItem[];
  delayMS?: number;
  autoplay?: boolean;
  slideIn?: boolean;
}
export const PartnersLanding = ({
  title,
  subtitle,
  topPartners,
  bottomPartners,
  delayMS = 0,
  autoplay = true,
  slideIn,
}: PartnersLandingProps) => {
  const { isIntersecting, ref } = useIntersectionObserver({
    threshold: 0,
  });

  const shouldStartAnimating = autoplay && isIntersecting;
  return (
    <div
      className={landingContainer}
      ref={ref}
      style={{ [partnersDelayVar]: delayMS + 'ms' } as React.CSSProperties}
    >
      <Grid className={landingTextContainer}>
        <H5 className={styledTitle}>{title}</H5>
        {subtitle && (
          <Body2 variant="secondary" className="mt-12">
            {subtitle}
          </Body2>
        )}
      </Grid>
      <Grid className={gridOverride}>
        <FadeContainer>
          <div
            className={logosContainer({
              slideIn,
            })}
          >
            {topPartners && !isEmpty(topPartners) && (
              <ScrollingLogos
                partners={topPartners}
                autoplay={shouldStartAnimating}
              />
            )}
            {bottomPartners && !isEmpty(bottomPartners) && (
              <ScrollingLogos
                autoplay={shouldStartAnimating}
                partners={bottomPartners}
                direction={ScrollingDirection.right}
                slowdown
              />
            )}
          </div>
        </FadeContainer>
      </Grid>
    </div>
  );
};
